import { NavLink } from 'react-router-dom';
import { ColourSwatch } from 'components/ColourSwatch/ColourSwatch';
import { deleteColourPalette } from 'apiCalls/apiCalls';
import { ErrorMessage, Loading, TextSpan } from 'components/CommonComponents';
import { Flexbox } from 'components/Flexbox';
import { COLOURS, PAD_EXTRA_LARGE_NUMBER, PAD_LARGE_NUMBER, PAD_SMALL_NUMBER } from 'providers/designSystem';
import { Box, IconButton } from '@mui/material';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';
import { useColourPalettes } from 'hooks/useColourPalettes';

const ColourPalette = ({ colourPalette }) => {
    return (
        <Box display="flex" flexDirection="column" width="240px" paddingRight="36px">
            <NavLink to={`/colour-palettes/${colourPalette.id}`}>
                <TextSpan>{colourPalette.name}</TextSpan>
            </NavLink>

            <Flexbox gap={PAD_SMALL_NUMBER}>
                {colourPalette.colours.map((colour, index) => {
                    return (
                        <ColourSwatch testId={`colour-swatch-${colour.id}`} key={colour.id} id={colour.id} size={'sm'} colour={colour} onClick={() => null} />
                    );
                })}
            </Flexbox>
        </Box>
    );
};

const ColourPalettesWithDeleteButton = ({ index, colourPalette, colourPalettes, setColourPalettes }) => {
    const handleDelete = () => {
        try {
            deleteColourPalette(colourPalette.id);
            const updatedColourPalettes = colourPalettes.filter(x => colourPalette.id !== x.id);
            setColourPalettes({ loading: false, result: updatedColourPalettes });
        } catch (error) {
            setColourPalettes({ loading: false, error: error.message });
        }
    };

    return (
        <Box position="relative">
            <ColourPalette key={index} colourPalette={colourPalette} />
            <Box position="absolute" top="0px" right="0px">
                <IconButton onClick={handleDelete}>
                    <ClearRoundedIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

const ColourPalettesResult = ({ colourPalettes, setColourPalettes }) => {
    return (
        <>
            {colourPalettes.map((colourPalette, index) => {
                return (
                    <ColourPalettesWithDeleteButton
                        index={index}
                        colourPalette={colourPalette}
                        colourPalettes={colourPalettes}
                        setColourPalettes={setColourPalettes}
                    />
                );
            })}
        </>
    );
};

export const DeleteColourPalettes = () => {
    const [colourPalettes, setColourPalettes] = useColourPalettes();

    return (
        <>
            {colourPalettes?.loading && <Loading />}
            {colourPalettes?.error && <ErrorMessage message="Something went wrong" />}
            {colourPalettes?.result && (
                <Flexbox
                    height="65vh"
                    gap={PAD_EXTRA_LARGE_NUMBER}
                    overflowY="scroll"
                    padding={PAD_LARGE_NUMBER}
                    border={`2px solid ${COLOURS.pink}`}
                    // @ts-ignore
                    borderRadius={[12, 0, 0, 12]}
                >
                    <ColourPalettesResult
                        colourPalettes={colourPalettes.result}
                        setColourPalettes={setColourPalettes}
                    />
                </Flexbox>
            )}
        </>
    );
};
